<template>
  <div class="live_system_header_container">
    <el-breadcrumb separator="/">
      <!--      <el-breadcrumb-item :to="{ path: '/index' }"></el-breadcrumb-item>-->
      <!--      <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">{{item}}</el-breadcrumb-item>-->
    </el-breadcrumb>
    <el-dropdown @command="handleCommand" menu-align='start'>
      <img src="../../../static/image/default.jpg" class="avator">
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="home">首页</el-dropdown-item>
        <el-dropdown-item command="userinfo">个人信息</el-dropdown-item>
        <el-dropdown-item command="signout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'LiveSystemTopHeader',
  methods: {
    async handleCommand (command) {
      console.log(command)
      if (command === 'home') {
        this.$router.push('/')
      } else if (command === 'signout') {
        this.$api.login.logout().then((res) => {
          console.log(res)
          this.$router.push('/login')
        })
      } else if (command === 'userinfo') {
        // this.$router.push('/')
        let routerPath = this.$route.path
        if (routerPath.indexOf('/stuIndex') >= 0) {
          this.$router.push('/stuIndex/userinfo')
        } else if (routerPath.indexOf('/teaIndex') >= 0) {
          this.$router.push('/teaIndex/userinfo')
        } else if (routerPath.indexOf('/assistantIndex') >= 0) {
          this.$router.push('/assistantIndex/userinfo')
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../style/mixin-bak';
  .live_system_header_container{
    background-color: #FFFFFF;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
  }
  .avator{
    .wh(36px, 36px);
    border-radius: 50%;
    margin-right: 37px;
  }
  .el-dropdown-menu__item{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/live/LiveSystemTopHeader.vue